module.exports = __webpack_public_path__ + "static/media/onestack-logo.9247ab58.svg";